import createClubsStore from "./clubs";
import createCountryStore from "./country";
import createGroupsStore from "./groups";
import createLeaguesStore from "./leagues";
import createSeasonsStore from "./seasons";
const createSuperAdminStore = (set, get) => ({
  groups: createGroupsStore(set, get),
  leagues: createLeaguesStore(set, get),
  countries: createCountryStore(set, get),
  clubs: createClubsStore(set, get),
  seasons: createSeasonsStore(set, get),
  // Reset all stores
  resetAll: () => {
    get().reset(); // Reset groups store
  },
});

export default createSuperAdminStore;
